import { Level } from "@sparkademy/app-common/models/level";
import { Module } from "@sparkademy/app-common/models/module";
import { atom } from "jotai";

export const levelsAtom = atom<Level[]>([]);
export const isSyncingAtom = atom<boolean>(false);

// enrolled modules -> standalone modules
export const modulesAtom = atom<Module[]>([]);
